const coreValuesList = [
	{
		title: "Unity and Support",
		info: "We believe in the power of community. GCAS builds relationships between Ghanaians and Canadians across Saskatchewan through ongoing programs and initiatives, creating a network members can rely on for guidance, assistance, and friendship.",
	},
	{
		title: "Preserving Our Cultural Heritage",
		info: "GCAS is committed to Ghana's cultural heritage through cultural events, language, traditional music and dance, and heritage celebrations. We pass these traditions to the next generation and share them with the wider community.",
	},
	{
		title: "Facilitating Integration",
		info: "Moving to a new country is hard. GCAS supports new Ghanaian immigrants settling into Saskatchewan with orientation, mentorship, language help, and guidance navigating local systems, so newcomers feel at home and become active members of the community.",
	},
];

export default coreValuesList;
